<odl-dialog
  class="note-dialog"
  [label]="'NOTE' | translate"
  [open]="true"
  (odl-close)="dialogClosed.emit()"
>
  <div class="note-dialog-wrapper">
    <div class="note-dialog-wrapper__quote" [style.--note-color]="colorMap[note()!.color]">
      <span class="note-dialog-wrapper__highlight" [nrEllipsis]="3">
        {{ note()!.selectedText }}
      </span>
    </div>
    <textarea
      [formControl]="noteControl"
      class="note-dialog-wrapper__input"
      [attr.id]="'note-dialog-wrapper__input-' + note()!.id"
      [attr.name]="'note-dialog-wrapper__input-' + note()!.id"
      [attr.aria-label]="'NOTE' | translate"
    ></textarea>
  </div>
  <div slot="footer" class="note-dialog-wrapper__footer">
    <odl-button
      [id]="`note-dialog-wrapper__actions-${note()!.id}`"
      [description]="'NAVIGATION.BOOKMARKS.MORE_ACTIONS' | translate"
    >
      <odl-icon name="more_vert" slot="only-icon" />
    </odl-button>
    <odl-button (click)="updateNote()" id="close-button">
      {{ 'DIALOG.BUTTONS.SAVE' | translate }}
    </odl-button>
  </div>

  <odl-menu [attr.for]="`#note-dialog-wrapper__actions-${note()!.id}`" placement="top-start">
    <odl-menu-item (odl-select)="handleCopySelectedText()">
      <odl-icon name="copy" slot="icon"></odl-icon>
      <span>{{ 'DIALOG.NOTE.COPY' | translate }}</span>
    </odl-menu-item>
    <odl-menu-item (odl-select)="shareNote.set(true)">
      <odl-icon name="share" slot="icon"></odl-icon>
      <span>{{ 'DIALOG.NOTE.SHARE_LINK' | translate }}</span>
    </odl-menu-item>
    <odl-menu-item (odl-select)="removeNote()">
      <odl-icon name="delete" slot="icon"></odl-icon>
      <span>{{ 'DIALOG.NOTE.DELETE' | translate }}</span>
    </odl-menu-item>
  </odl-menu>
</odl-dialog>

<odl-tooltip [attr.for]="`#note-dialog-wrapper__actions-${note()!.id}`">
  {{ 'NAVIGATION.BOOKMARKS.MORE_ACTIONS' | translate }}
</odl-tooltip>
